import { TChapter } from "@/zapi-frontend/shared/types/projects";
import {
  DEEP_DIVE_SECTIONS,
  FULL_SUMMARY_SLUG,
  findExecSummaryChapter,
  isAppendixChapter
} from "@/zapi-frontend/shared/lib/projectChapters";

export const VALUE_CHAIN_SECTION = "market-analysis";

export function groupProjectChapters(projectChapters: TChapter[]) {
  const execChapter = findExecSummaryChapter(projectChapters);
  const memoChapter = projectChapters.find((c) => c.projectTemplateChapter.slug === FULL_SUMMARY_SLUG);
  const specialIds = new Set([execChapter?.id, memoChapter?.id]);

  const appendices = projectChapters.filter((c) => !specialIds.has(c.id) && !c.isHidden && isAppendixChapter(c));
  const regular = projectChapters.filter((c) => !specialIds.has(c.id) && !c.isHidden && !isAppendixChapter(c));

  const templateHasSections = regular.some((c) => c.projectTemplateChapter.section);
  const sections = DEEP_DIVE_SECTIONS.map((s) => ({
    ...s,
    chapters: regular.filter((c) => c.projectTemplateChapter.section === s.key)
  }));
  // A regular chapter without a section means the template marks it hidden (or exec) —
  // e.g. an old project where the chapter is still visible. Group it under Hidden Chapters.
  // If the template has no sections at all (not migrated yet), keep the flat list instead.
  const unsectioned = templateHasSections ? [] : regular.filter((c) => !c.projectTemplateChapter.section);
  const hiddenChapters = [
    ...projectChapters.filter((c) => !specialIds.has(c.id) && c.isHidden),
    ...(templateHasSections ? regular.filter((c) => !c.projectTemplateChapter.section) : [])
  ];

  return { execChapter, memoChapter, appendices, hiddenChapters, sections, unsectioned };
}

export type TProjectChapterGroups = ReturnType<typeof groupProjectChapters>;
